import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/fx-rate/manage.php`,
  API_SEARCH: `/ERP/fx-rate/search.php`,
};

/* อัตราแลกเปลี่ยนรายเดือน (ฝ่ายบัญชีคีย์) */
const FxRateService = () => {
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (id) => api.delete(`${API_URL.API_MANAGE}?id=${id}`);
  /* เรตของงวด/สกุลเงินที่ต้องการ ใช้ตอนแปลงยอดเป็นเงินบาท */
  const rateOf = (period, currency) =>
    api.get(`${API_URL.API_MANAGE}?period=${period}&currency=${currency}`, {
      ignoreLoading: true,
    });
  const search = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_SEARCH}`, parm, { ...config, cancle: true });

  return { create, update, deleted, rateOf, search };
};

export default FxRateService;
